/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  // document.addEventListener('DOMContentLoaded', () => {
  //   const currentUrl = window.origin+"/"; // Get the current path from window.location
  //   // Dynamically set the apiUrl based on the current URL
  //   environment.apiUrl = currentUrl;
  
  // });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
